import { lazy } from 'react';
import type { ToolConfig } from '@/types/tool';

export const base64ConverterConfig: ToolConfig = {
  id: 'base64-converter',
  path: '/tools/base64-converter',
  meta: {
    title: 'Base64 Converter',
    description: 'Encode and decode text to/from Base64 format. No data leaves your browser.',
    keywords: ['base64', 'encode', 'decode', 'converter', 'text'],
    icon: 'Binary',
    category: 'security',
    gradient: 'from-violet-500 to-purple-600',
  },
  component: lazy(() => import('./Base64Converter')),
};
